import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProjectsHero from './components/ProjectsHero';
import ProjectsGrid from './components/ProjectsGrid';
import ProjectsCTA from './components/ProjectsCTA';
import SeoHead from '@/components/base/SeoHead';

export default function ProjectsPage() {
  const [scrolled, setScrolled] = useState(false);
  const { i18n } = useTranslation();
  const isTR = i18n.language === 'tr' || i18n.language?.startsWith('tr');

  const seo = isTR
    ? {
        title: 'LED Aydınlatma Projeleri | OKAYISU Referans Portföy İstanbul',
        description: 'OKAYISUnun Türkiye ve dünya genelinde tamamladığı LED aydınlatma projeleri. Otel, AVM, endüstriyel tesis, stadyum, havalimanı ve mimari yapılardan oluşan kapsamlı referans portföyü.',
        keywords: 'LED aydınlatma projeleri, referans projeler, aydınlatma portföy, mimari aydınlatma, ticari aydınlatma',
        canonicalUrl: 'https://www.okayisu.com/projeler',
        lang: 'tr',
      }
    : {
        title: 'LED Lighting Projects | OKAYISU Reference Portfolio Istanbul',
        description: 'OKAYISU completed LED lighting projects across Türkiye and worldwide. A comprehensive reference portfolio including hotels, shopping malls, industrial facilities, stadiums, airports, and architectural structures.',
        keywords: 'LED lighting projects, reference portfolio, architectural lighting, commercial lighting, industrial lighting',
        canonicalUrl: 'https://www.okayisu.com/en/projeler',
        lang: 'en',
      };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <SeoHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        lang={seo.lang}
      />
      <Navbar />
      <div className="pt-20">
        <ProjectsHero />
      </div>
      <ProjectsGrid />
      <ProjectsCTA />
      <Footer />
    </div>
  );
}